/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {KTSVG, toAbsoluteUrl} from '../../../_metronic/helpers'
import './style.css'
import 'react-date-range/dist/styles.css' // main css file
import 'react-date-range/dist/theme/default.css' // theme css file
import 'react-date-range/dist/styles.css' // main style file
import 'react-date-range/dist/theme/default.css' // theme css file
import Select from 'react-select'
import DateRanger from '../dashboard/DateRanger'
import CustomerWiseShipmentBarChart from '../dashboard/CustomerWiseShipmentBarChart'
import OnTimeAndLatePieChart from '../dashboard/OnTimeAndLatePieChart'
import DeliveryRegionDonutChart from '../dashboard/DeliveryRegionDonutChart'
import DamageLostPieChart from '../dashboard/GPSPieChart'
import './style.css'
import OperationDeliveryRegionDonutChart from './OperationDeliveryRegionDonutChart'
import {useGetCustomerRowOneQuery} from '../../redux/network/CustomerDashboardApi'
import {useSelector} from 'react-redux'

interface Dashboard2Props {
  currency: string
  customersGrid: {
    totalShipment: number
    totalKMs: number
    totalDeliveryTime: number
  }
  isFiltered: boolean
}

const Dashboard2: FC<Dashboard2Props> = ({currency, customersGrid, isFiltered}) => (
  <>
    <div className=''>
      <div className='d-flex flex-wrap flex-stack mb-4 py-2 ps-3 rounded mb-3'>
        <div className='d-flex align-items-start d-flex flex-column'>
          <h1 className='text-dark fw-bold my-1'>Customer Dashboard</h1>
          <p className='text-gray-600 fw-semibold fs-5 mb-0'>
            Seamless Vehicle Operations Monitoring
          </p>
        </div>
        <div className='d-flex justify-content-end px-2'>
          {/* <div className='min-w-150px'>
            <Select options={options} placeholder='Select Customer' styles={customStyles} />
          </div> */}
          <div className='m-0'>
            <a
              href='#'
              className={`btn btn-sm btn-flex fw-semibold bg-white ms-3 border border-1 border-gray-300 py-3
                ${isFiltered 
                  ? 'bg-danger text-white' 
                  : 'text-gray-600 bg-hover-danger text-hover-white'
                }`}
              data-kt-menu-trigger='click'
              data-kt-menu-placement='bottom-end'
            >
              <KTSVG
                path='/media/icons/duotune/files/fil002.svg'
                className={`svg-icon-6 ${isFiltered ? 'text-white' : 'svg-icon-danger'} me-3`}
              />
              Filter Date Range
            </a>
            <DateRanger />
          </div>
        </div>
      </div>
      <div className='mx-2'>
        <div className='row gx-4 gy-2 mb-1'>
          <div className='col-lg-12 col-xl-6 col-xxl-4'>
            <div
              className='card mb-xl-2 w-100'
              style={{
                border: '1px solid rgba(236, 111, 102, 0.1)',
              }}
            >
              <div className='card-body small-card-padding rounded'>
                <div className='d-flex align-items-center flex-w'>
                  {' '}
                  <div className='rounded small-card-img'>
                    <div className='symbol symbol-50px me-4 p-1 bg-light-danger'>
                      <KTSVG
                        path='/media/icons/duotune/finance/fin006.svg'
                        className='svg-icon-danger svg-icon-3hx'
                      />
                    </div>
                  </div>
                  <div className='d-flex flex-column w-100 text-start align-items-center '>
                    <div className='d-flex justify-content-between flex-1 w-100'>
                      <span className='card-title-sub fw-semibold text-gray-600 mt-2 mt-lg-0'>
                        Total Shipment
                      </span>
                    </div>
                    <div className='d-flex justify-content-between  w-100'>
                      <span
                        className='d-flex align-items-center card-titles'
                        style={{fontWeight: 600}}
                      >
                        {customersGrid.totalShipment}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='col-lg-12 col-xl-6 col-xxl-4'>
            <div
              className='card mb-xl-2 w-100'
              style={{
                border: '1px solid rgba(236, 111, 102, 0.1)',
              }}
            >
              <div className='card-body small-card-padding rounded'>
                <div className='d-flex align-items-center flex-w'>
                  {' '}
                  <div className='rounded small-card-img'>
                    <div className='symbol symbol-50px me-4 p-1 bg-light-danger'>
                      <KTSVG
                        path='/media/icons/duotune/graphs/gra005.svg'
                        className='svg-icon-danger svg-icon-3hx'
                      />
                    </div>
                  </div>
                  <div className='d-flex flex-column w-100 text-start align-items-center '>
                    <div className='d-flex justify-content-between flex-1 w-100'>
                      <span className='card-title-sub fw-semibold text-gray-600 mt-2 mt-lg-0'>
                        Total KMs
                      </span>
                    </div>
                    <div className='d-flex justify-content-between  w-100'>
                      <span
                        className='d-flex align-items-center card-titles'
                        style={{fontWeight: 600}}
                      >
                        {customersGrid.totalKMs.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='col-lg-12 col-xl-12 col-xxl-4'>
            <div
              className='card mb-xl-2 w-100'
              style={{
                border: '1px solid rgba(236, 111, 102, 0.1)',
              }}
            >
              <div className='card-body small-card-padding rounded'>
                <div className='d-flex align-items-center flex-w'>
                  {' '}
                  <div className='rounded small-card-img '>
                    <div className='symbol symbol-50px me-4 p-1 bg-light-danger'>
                      <KTSVG
                        path='/media/icons/duotune/general/gen013.svg'
                        className='svg-icon-danger svg-icon-3hx'
                      />
                    </div>
                  </div>
                  <div className='d-flex flex-column w-100 text-start align-items-center '>
                    <div className='d-flex justify-content-between flex-1 w-100'>
                      <span className='card-title-sub fw-semibold text-gray-600 mt-2 mt-lg-0'>
                        Total Delivery Time
                      </span>
                      {/* <div className='d-flex align-items-center'>
                    <KTSVG
                      path='/media/icons/duotune/arrows/arr066.svg
                      className='svg-icon-1 svg-icon-success me-2'
                    />
                    <div className='fs-2 fw-bolder text-success'>3%</div>
                  </div> */}
                    </div>
                    <div className='d-flex justify-content-between  w-100'>
                      <span
                        className='d-flex align-items-center card-titles'
                        style={{fontWeight: 600}}
                      >
                        {customersGrid.totalDeliveryTime.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })} Hours
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='mx-2'>
        <div className='row gx-4 gy-2'>
          {/* <div className='col-lg-12 col-xl-12 col-xxl-12'>
            {' '}
            <CustomerWiseShipmentBarChart currency={currency} />
          </div> */}

          <div className='col-lg-12 col-xl-6 col-xxl-4 mt-3'>
            {' '}
            <OnTimeAndLatePieChart />
          </div>
          <div className='col-lg-12 col-xl-6 col-xxl-8 mt-3'>
            {' '}
            <OperationDeliveryRegionDonutChart currency={currency} />
          </div>
          {/* <div className='col-lg-12 col-xl-6 col-xxl-4'>
            {' '}
            <DamageLostPieChart />
          </div> */}
        </div>
      </div>
    </div>
  </>
)
interface OparationDashboardPageProps {
  currency: string // Receive the currency as a prop
}
const OperationDashboard: FC<OparationDashboardPageProps> = ({currency}) => {
  const {startDate, endDate, isFiltered} = useSelector((state: any) => state.Filter.Filter)
  const {data: rowData, error: rowError} = useGetCustomerRowOneQuery(
    {startDate, endDate},
    {
      refetchOnMountOrArgChange: true,
      pollingInterval: isFiltered ? 0 : 10000,
      skip: false,
    }
  )

  const customersGrid = {
    totalShipment: rowData?.totalShipment
      ? parseFloat(Number(rowData.totalShipment).toFixed(3))
      : 0,
    totalKMs: rowData?.totalKMs ?? 0,
    totalDeliveryTime: rowData?.totalDeliveryTime ?? 0,
  }

  return (
    <>
      {/* <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.DASHBOARD'})}</PageTitle> */}
      <Dashboard2 currency={currency} customersGrid={customersGrid} isFiltered={isFiltered} />
    </>
  )
}

export {OperationDashboard}
